<template>
    <div :class="isScroll">
      <div style="width: 95%;">
      <template v-if="showVForm">
        <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Tipo">
                  <multiselect
                    placeholder="Tipo"
                    deselect-label="Click o enter para deseleccionar"
                    select-label="Click o enter para seleccionar"
                    tag-placeholder="Añadir nuevo tipo"
                    :taggable="true"
                    @tag="addTag"
                    v-model="newVehiculo.aparato_or_vehiculo"
                    :options="aparatos_tipos_options"
                    :multiple="false"
                    :close-on-select="true"
                    :preselect-first="false">
                  </multiselect>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Potencia o consumo">
                  <b-form-input data-vv-scope="gestion" v-validate="'numeric'" name="Potencia o consumo" v-model="newVehiculo.potencia_or_consumo" :disabled="!hasPermision('E')"></b-form-input>
                  <span class="error">{{ errors.first('gestion.Potencia o consumo') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: right;" v-if="hasPermision('E')">
                <b-button @click="showVForm = false">Cancelar</b-button>
                <b-button @click="saveVForm">Guardar</b-button>
            </b-col>
        </b-row>
      </template>
      <template v-else-if="showCForm">
        <b-row>
          <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Combustible">
                  <multiselect
                    data-vv-scope="gestion" v-validate="'required'"
                    name="Combustible"
                    placeholder="Combustible"
                    deselect-label="Click o enter para deseleccionar"
                    select-label="Click o enter para seleccionar"
                    tag-placeholder="Añadir nuevo combustible"
                    :taggable="true"
                    @tag="addTag_comb_tipo"
                    v-model="newCombustible.combustible"
                    :options="combustibles_tipos_options"
                    :multiple="false"
                    :close-on-select="true"
                    :preselect-first="false">
                  </multiselect>
                  <span class="error">{{ errors.first('gestion.Combustible') }}</span>

                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Uso">
                  <multiselect
                    data-vv-scope="gestion" v-validate="'required'"
                    name="Uso"
                    placeholder="Uso"
                    deselect-label="Click o enter para deseleccionar"
                    select-label="Click o enter para seleccionar"
                    tag-placeholder="Añadir nuevo uso"
                    :taggable="true"
                    @tag="addTag_comb_uso"
                    v-model="newCombustible.uso"
                    :options="combustibles_usos_options"
                    :multiple="false"
                    :close-on-select="true"
                    :preselect-first="false">
                  </multiselect>
                  <span class="error">{{ errors.first('gestion.Uso') }}</span>

                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Consumo anual (kWh/Año)">
                  <b-form-input data-vv-scope="gestion" v-validate="'numeric'" name="Consumo anual (kWh/Año)" v-model="newCombustible.consumo_anual" :disabled="!hasPermision('E')"></b-form-input>
                  <span class="error">{{ errors.first('gestion.Consumo anual (kWh/Año)') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: right;" v-if="hasPermision('E')">
                <b-button @click="showCForm = false">Cancelar</b-button>
                <b-button @click="saveCForm">Guardar</b-button>
            </b-col>
        </b-row>
      </template>
      <template v-else-if="showPptoForm || showPptoTable || editPptoFlag">
        <template v-if="showPptoForm">
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Dirección estructurada">
                  <b-form-input v-model="detalles.direccion_estructurada" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Dirección no estructurada">
                  <b-form-input v-model="detalles.direccion_no_estructurada" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Código postal">
                  <b-form-input v-model="detalles.codigo_postal" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Provincia">
                  <b-form-input v-model="detalles.provincia" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Municipio">
                  <b-form-input v-model="detalles.municipio" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Población">
                  <b-form-input v-model="detalles.poblacion" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-input-group>
                  <input type="text" class="form-control" v-model="text" @keyup.enter="search">

                  <b-input-group-append>
                      <b-btn v-if="!loading" variant="info" @click="search">
                        Buscar
                        <i class="fa fa-search"></i>
                      </b-btn>
                      <b-btn v-else variant="info" disabled>
                        <i class="fa fa-spinner fa-pulse" style="padding-left: 0em;"></i>
                      </b-btn>
                  </b-input-group-append>
                  <b-input-group-append>
                      <b-btn v-if="!loading" variant="danger" @click="clearSearch">
                        Limpiar
                        <i class="fa fa-times"></i>
                      </b-btn>
                  </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="4" style="text-align: right;" v-if="hasPermision('E')">
              <b-button @click="cancelPptoList">Cancelar</b-button>
              <b-button @click="savePptoForm">Guardar</b-button>
            </b-col>
          </b-row>
          <br>
          <div v-for="(entidad, $index) in entidades" :key="$index">
            <EntidadSlot :entidad="entidad" @select="select" @deselect="deselect"></EntidadSlot>
          </div>
          <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
            <div slot="no-more">No hay más entidades</div>
            <div slot="no-results">No se han encontrado entidades</div>
          </infinite-loading>
        </template>
        <template v-else-if="editPptoFlag">
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Entidad">
                  <b-form-input v-model="editPpto.id_entidad.nombre_entidad" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Status">
                  <b-form-select @input="updateDate" v-model="editPpto.status" :options="ppto_status_options" class="mb-3"/>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Fecha cambio status">
                  <b-form-input v-model="editPpto.update_date" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
              <b-form-group style="font-size: 1rem;" label="Fecha entregado">
                <b-input-group>
                  <datetime
                  data-vv-scope="gestion" v-validate="(editPpto.status === 'Enviado') ? 'required':''"
                  name="Fecha entregado"
                  v-model="editPpto.fecha_entregado"
                  input-class="form-control"
                  :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                  type="datetime"
                  :auto="true"
                  :minute-step="15"
                  value-zone="local"
                  zone="local">
                  </datetime>
                  <b-input-group-text slot="append" @click="editPpto.fecha_entregado = ''">
                    <strong class="text-danger"><i class="fa fa-times"></i></strong>
                  </b-input-group-text>
                </b-input-group>
                <span class="error">{{ errors.first('gestion.Fecha entregado') }}</span>
              </b-form-group>
            </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Observaciones">
                  <b-form-input v-model="editPpto.observaciones"></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row style="min-height: 10rem;">
            <b-col style="text-align: right;" v-if="hasPermision('E')">
                  <b-button @click="editPptoFlag = false">Cancelar</b-button>
                  <b-button @click="saveEditPpto">Guardar</b-button>
              </b-col>
          </b-row>
        </template>
        <template v-else-if="showPptoTable">
          <b-table v-if="presupuestos.length>0" striped hover :items="presupuestos" :fields="table_fields">
            <template slot="entidad" slot-scope="row">
              {{row.item.id_entidad.nombre_entidad}}
            </template>
            <template slot="actions" slot-scope="row">
              <b-dropdown variant="link" no-caret>
                <template slot="button-content"><i class="fa fa-ellipsis-v" aria-hidden="true"></i></template>
                <b-dropdown-item-button @click="deletePresupuesto(row.item)" v-if="hasPermision('E')">Eliminar</b-dropdown-item-button>
                <b-dropdown-item-button @click="editPresupuesto(row.item)" v-if="hasPermision('E')">Editar</b-dropdown-item-button>
              </b-dropdown>
            </template>
          </b-table>
          <br>
          <b-row>
            <b-col style="text-align: right;" v-if="hasPermision('E')">
                  <b-button @click="showPptoTable = false">Atras</b-button>
                  <b-button @click="addNewPpto">Añadir presupuesto</b-button>
              </b-col>
          </b-row>
        </template>
      </template>
      <template v-else>
        <template v-if="loading>0">
          <Loader :delay="0"></Loader>
        </template>
        <div v-else>
          <b-row>
              <b-col>
                <b-form>
                  <b-form-group style="font-size: 1rem;" label="Clase establecimiento GN">

                    <b-form-select v-if="type==='caldera'" data-vv-scope="gestion" v-validate="''" name="Clase establecimiento GN" v-model="detalles['id_clase_establecimiento_gn_'+type].id" :options="clase_establecimiento_comercial_options" class="mb-3" text-field="tipo" value-field="id" disabled/>
                    <b-form-select v-else data-vv-scope="gestion" v-validate="'required'" name="Clase establecimiento GN" v-model="detalles['id_clase_establecimiento_gn_'+type].id" :options="clase_establecimiento_comercial_options" class="mb-3" text-field="tipo" value-field="id" :disabled="!hasPermision('E')"/>
                    <span class="error">{{ errors.first('gestion.Clase establecimiento GN') }}</span>
                  </b-form-group>

                </b-form>
              </b-col>
              <b-col>
                <b-form>
                  <b-form-group v-if="type==='comercial'" style="font-size: 1rem;" label="Gas en finca">
                    <b-form-select data-vv-scope="gestion" v-validate="isRequired2" name="Gas en finca" v-model="detalles.id_gas_finca.id" :options="gas_options" class="mb-3" text-field="gas" value-field="id" :disabled="!hasPermision('E')"/>
                    <span class="error">{{ errors.first('gestion.Gas en finca') }}</span>
                  </b-form-group>
                  <b-form-group v-if="type==='caldera'" style="font-size: 1rem;" label="Gas en finca">
                    <b-form-select data-vv-scope="gestion" v-validate="'required'" name="Gas en finca" v-model="detalles.id_gas_en_finca.id" :options="gas_options" class="mb-3" text-field="gas" value-field="id" :disabled="!hasPermision('E')"/>
                    <span class="error">{{ errors.first('gestion.Gas en finca') }}</span>
                  </b-form-group>
                </b-form>
              </b-col>
              <b-col>
                <b-form>
                  <b-form-group style="font-size: 1rem;" label="Status gestión">
                    <b-form-select data-vv-scope="gestion" v-validate="'required'" name="Status gestión" v-model="detalles['id_status_gestion_'+type].id" :options="status_options" class="mb-3" text-field="status" value-field="id" :disabled="!hasPermision('E')" @input="setFechaCambioStatus"/>
                    <span class="error">{{ errors.first('gestion.Status gestión') }}</span>
                  </b-form-group>
                </b-form>
              </b-col>
              <b-col>
                <b-form>
                  <b-form-group style="font-size: 1rem;" label="Fecha cambio status">
                    <datetime
                      v-model="detalles.fecha_cambio_status"
                      input-class="form-control"
                      :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                      type="date"
                      :auto="true"
                      value-zone="local"
                      zone="local"
                      disabled>
                    </datetime>
                  </b-form-group>
                </b-form>
              </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Es cliente">
                  <b-form-select data-vv-scope="gestion" v-validate="isRequired" name="Es cliente" v-model="detalles.cliente" :options="cliente_options" class="mb-3" text-field="text" value-field="value" :disabled="!hasPermision('E')"/>
                  <span class="error">{{ errors.first('gestion.Es cliente') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="3">
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Motivo no potencial">
                  <b-form-select data-vv-scope="gestion" v-validate="noPotencialValidate" name="Motivo no potencial" v-model="detalles.motivo_no_potencial" :options="motivo_no_potencial_options" class="mb-3" text-field="motivo" value-field="motivo" :disabled="!hasPermision('E')"/>
                  <span class="error">{{ errors.first('gestion.Motivo no potencial') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="3">
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Motivo rechazo">
                  <b-form-select data-vv-scope="gestion" v-validate="rechazadoValidate"  name="Motivo rechazo" v-model="detalles.motivo_rechazo" :options="motivo_rechazo_options" class="mb-3" text-field="motivo" value-field="motivo" :disabled="!hasPermision('E')"/>
                  <span class="error">{{ errors.first('gestion.Motivo rechazo') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-button style="margin-top: 2rem;" @click="showPptoTable = true">Presupuestos
                <b-badge variant="info">{{presupuestos.length}}</b-badge>
              </b-button>
              <b-button v-if="presupuestos.length>0" variant="info" style="margin-top: 2rem;" @click="sendEmail">
                Enviar correo <i class="fa fa-envelope"></i>
              </b-button>
            </b-col>

          </b-row>
          <b-row>
              <b-col>
                  <p class="col-form-label">{{aparatos_string}}</p>
                  <p v-if="aparatos.length===0" style="color:cornflowerblue"><i>Ningún aparato añadido</i></p>
                  <b-table v-else style="max-height: 25rem;" responsive striped hover :items="aparatos" :fields="[
                    {key:'aparato_or_vehiculo', label:'Aparato'},
                    {key:'potencia_or_consumo', label:'Potencia'},
                    {key:'actions', label:''},
                  ]">
                    <template slot="actions" slot-scope="row" v-if="hasPermision('E')">
                        <b-button @click="editAparato(row.item)">Editar</b-button>
                        <b-button @click="deleteAparato(row.item)">Borrar</b-button>
                    </template>
                  </b-table>
                  <b-button v-if="hasPermision('E')" @click="addVehiculo">Añadir</b-button>
              </b-col>
              <b-col>
                  <p class="col-form-label">Combustibles, usos y consumo anual</p>
                  <p v-if="combustibles.length===0" style="color:cornflowerblue"><i>Ningún combustible añadido</i></p>
                  <b-table style="max-height: 25rem;" responsive v-else striped hover :items="combustibles" :fields="[
                    {key:'combustible', label:'Combustible'},
                    {key:'uso', label:'Uso'},
                    {key:'consumo_anual', label:'Consumo anual'},
                    {key:'actions', label:''},
                  ]">
                    <template slot="actions" slot-scope="row" v-if="hasPermision('E') && type==='comercial'">
                      <b-button @click="editCombustible(row.item)">Editar</b-button>
                      <b-button @click="deleteCombustible(row.item)">Borrar</b-button>
                    </template>
                  </b-table>
                  <b-button v-if="hasPermision('E') && type==='comercial'" @click="addCombustible">Añadir</b-button>
              </b-col>
          </b-row>
          <hr>
          <b-row v-if="type==='comercial'">
              <b-col>
                <b-form>
                  <b-form-group style="font-size: 1rem;" label="Nombre propietario">
                      <b-form-input
                      data-vv-scope="gestion" v-validate="(sendingEmail) ? 'required':''"
                      name="Nombre propietario"
                      v-model="detalles.nombre_propietario" :disabled="!hasPermision('E')"></b-form-input>
                      <span class="error">{{ errors.first('gestion.Nombre propietario') }}</span>
                  </b-form-group>
                </b-form>
            </b-col>
            <b-col>
                <b-form>
                  <b-form-group style="font-size: 1rem;" label="Teléfono propietario">
                      <b-form-input
                      data-vv-scope="gestion" v-validate="(sendingEmail) ? 'required':''"
                      name="Teléfono propietario"
                      v-model="detalles.telefono_propietario" :disabled="!hasPermision('E')"></b-form-input>
                      <span class="error">{{ errors.first('gestion.Teléfono propietario') }}</span>
                  </b-form-group>
                </b-form>
            </b-col>
            <b-col>
                <b-form>
                  <b-form-group style="font-size: 1rem;" label="Email propietario">
                      <b-form-input v-model="detalles.email_propietario"
                      name="Email propietario"
                      data-vv-scope="gestion" v-validate="(sendingEmail) ? 'required':''"
                      :disabled="!hasPermision('E')"></b-form-input>
                      <span class="error">{{ errors.first('gestion.Email propietario') }}</span>
                  </b-form-group>
                </b-form>
            </b-col>
          </b-row>
          <b-row v-if="type==='caldera'">
              <b-col>
                <b-form>
                  <b-form-group style="font-size: 1rem;" label="Nombre presidente">
                      <b-form-input
                      data-vv-scope="gestion" v-validate="(sendingEmail) ? 'required':''"
                      name="Nombre presidente"
                      v-model="detalles.nombre_presidente" :disabled="!hasPermision('E')"></b-form-input>
                      <span class="error">{{ errors.first('gestion.Nombre presidente') }}</span>
                  </b-form-group>
                </b-form>
            </b-col>
            <b-col>
                <b-form>
                  <b-form-group style="font-size: 1rem;" label="Teléfono presidente">
                      <b-form-input
                      data-vv-scope="gestion" v-validate="(sendingEmail) ? 'required':''"
                      name="Teléfono presidente"
                      v-model="detalles.telefono_presidente" :disabled="!hasPermision('E')"></b-form-input>
                      <span class="error">{{ errors.first('gestion.Teléfono presidente') }}</span>
                  </b-form-group>
                </b-form>
            </b-col>
            <b-col>
                <b-form>
                  <b-form-group style="font-size: 1rem;" label="Email presidente">
                      <b-form-input
                        data-vv-scope="gestion" v-validate="(sendingEmail) ? 'required':''"
                        name="Email presidente"
                        v-model="detalles.email_presidente"
                        :disabled="!hasPermision('E')">
                      </b-form-input>
                      <span class="error">{{ errors.first('gestion.Email presidente') }}</span>
                  </b-form-group>
                </b-form>
            </b-col>
          </b-row>
          <b-row v-if="type==='caldera'">
              <b-col>
                <b-form>
                  <b-form-group style="font-size: 1rem;" label="Nombre administrador finca">
                      <b-form-input v-model="detalles.nombre_administrador_finca" :disabled="!hasPermision('E')"></b-form-input>
                  </b-form-group>
                </b-form>
            </b-col>
            <b-col>
                <b-form>
                  <b-form-group style="font-size: 1rem;" label="Teléfono administrador finca">
                      <b-form-input v-model="detalles.telefono_administrador_finca" :disabled="!hasPermision('E')"></b-form-input>
                  </b-form-group>
                </b-form>
            </b-col>
            <b-col>
                <b-form>
                  <b-form-group style="font-size: 1rem;" label="Email administrador finca">
                      <b-form-input
                      v-model="detalles.email_administrador_finca" :disabled="!hasPermision('E')"></b-form-input>
                  </b-form-group>
                </b-form>
            </b-col>
          </b-row>
          <b-row>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Observaciones">
                        <b-form-input v-model="detalles.observaciones" :disabled="!hasPermision('E')"></b-form-input>
                    </b-form-group>
                  </b-form>
              </b-col>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Datos de contacto">
                        <b-form-input v-model="detalles.datos_contacto" :disabled="!hasPermision('E')"></b-form-input>
                    </b-form-group>
                  </b-form>
              </b-col>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Empresa instaladora">
                        <b-form-input v-model="detalles.empresa_instaladora" :disabled="!hasPermision('E')"></b-form-input>
                    </b-form-group>
                  </b-form>
              </b-col>
          </b-row>
          <b-row>
            <b-col style="text-align: right;" v-if="hasPermision('E')">
                <b-button @click="cancel">Cancelar</b-button>
                <b-button @click="save($event)">Guardar</b-button>
            </b-col>
          </b-row>
        </div>
        <br>
      </template>
      </div>
    </div>
</template>

<script>
import Switches from 'vue-switches';
import Loader from '@/components/Layout/Loader.vue';
import InfiniteLoading from 'vue-infinite-loading';
import EntidadSlot from './EntidadSlot';
import moment from 'moment';

export default {
  inject: {
    $validator: '$validator'
  },
  name: 'ComercialGestion',
  props: ['feature', 'type', 'permisos', 'newComercial'],
  components: {
    Switches,
    Loader,
    InfiniteLoading,
    EntidadSlot
  },
  data () {
    return {
      infiniteId: +new Date(),
      text: '',
      search_text: '',
      disabled_entidades: [],
      sendingEmail: false,
      editPptoFlag: false,
      ppto_status_options: ['Solicitado', 'Enviado', 'Aceptado', 'Cancelado'],
      editPpto: null,
      table_fields: ['actions', 'entidad', 'fecha_solicitado', 'fecha_entregado', 'status', 'observaciones'],
      presupuestos: [],
      showPptoTable: false,
      showPptoForm: false,
      busy: false,
      loading: 1,
      detalles: {},
      clase_establecimiento_comercial_options: [],
      gas_options: [],
      status_options: [],
      motivo_no_potencial_options: [],
      motivo_rechazo_options: [],
      cliente_options: [{value: null, text: ''}, {value: true, text: 'Sí'}, {value: false, text: 'No'}],
      aparatos: [],
      combustibles: [],
      showVForm: false,
      aparatos_tipos_options: [],
      newVehiculo: {
        id: null,
        potencia_or_consumo: null,
        tipo: 'APARATO',
        aparato_or_vehiculo: null,
        id_comercial: null
      },
      showCForm: false,
      combustibles_tipos_options: [],
      combustibles_usos_options: [],
      newCombustible: {
        id: null,
        uso: null,
        combustible: null,
        consumo_anual: null,
        id_comercial: null
      },
      page: 1,
      entidades: [],
      selected_entidades: [],
      aparatos_string: 'Aparatos y potencia'
    };
  },
  methods: {
    clearSearch: function () {
      this.text = '';
      this.search();
    },
    search: function () {
      this.search_text = this.text;
      this.page = 1;
      this.entidades = [];
      this.infiniteId += 1;
    },
    cancelPptoList: function () {
      this.showPptoForm = false;
      this.page = 1;
    },
    sendEmail: function () {
      if (!this.sendingEmail) {
        this.sendingEmail = true;
        setTimeout(this.save, 200);
      }
    },
    addTag: function (newTag) {
      this.aparatos_tipos_options.push(newTag);
      this.newVehiculo.aparato_or_vehiculo = newTag;
    },
    addTag_comb_tipo: function (newTag) {
      this.combustibles_tipos_options.push(newTag);
      this.newCombustible.combustible = newTag;
    },
    addTag_comb_uso: function (newTag) {
      this.combustibles_usos_options.push(newTag);
      this.newCombustible.uso = newTag;
    },
    addNewPpto: function () {
      this.entidades = [];
      this.showPptoForm = true;
    },
    updateDate: function () {
      this.editPpto.update_date = moment().format();
    },
    editPresupuesto: function (p) {
      this.editPpto = p;
      this.editPptoFlag = true;
    },
    saveEditPpto: function () {
      this.$validator.validate().then(result => {
        if (!result) {
          alert('Tienes algún error en el formulario');
        } else {
          this.editPpto.id_entidad = this.editPpto.id_entidad.id;
          // delete this.editPpto.id_entidad

          if (this.editPpto.fecha_entregado === '') {
            this.editPpto.fecha_entregado = null;
          }

          this.$http.put('presupuestos_' + this.type + '2/' + this.editPpto.id + '/', this.editPpto).then(result => {
            this.loadPptos();
            this.editPptoFlag = false;
          });
        }
      });
    },
    deletePresupuesto: function (p) {
      this.$http.delete('presupuestos_' + this.type + '/' + p.id + '/').then(result => {
        this.loadPptos();
      });
    },
    select: function (entidad) {
      this.selected_entidades.push(entidad);
    },
    deselect: function (entidad) {
      this.selected_entidades = this.selected_entidades.filter(e => e.id !== entidad.id);
    },
    infiniteHandler ($state) {
      const idList = this.presupuestos.map(e => e.id_entidad.id);

      this.$http.get('entities_paginated/', {
        params: {
          page: this.page,
          search: this.search_text,
          // id__not_in: idList,
          ambitos__mercado: (this.type === 'comercial') ? 'GC' : 'CC',
          ambitos__codigo_provincia_ine: this.detalles.codigo_provincia_zeus
        }
      }).then(result => {
        this.entidades.push(...result.data.results);
        var selected = result.data.results.filter(e => idList.indexOf(e.id) > -1);
        for (let index = 0; index < selected.length; index++) {
          var element = selected[index];
          element.disabled = true;
        }
        if (result.data.results.length > 0) {
          $state.loaded();
        }
        if (result.data.next) {
          this.page += 1;
        } else {
          $state.complete();
        }
      });
    },
    savePptoForm: function () {
      var list = [];
      var data = [];
      for (let index = 0; index < this.selected_entidades.length; index++) {
        const element = this.selected_entidades[index];
        data.push({});
        data[index]['id_' + this.type] = this.detalles.id;
        data[index].id_entidad = element.id;
        data[index].status = 'Solicitado';
        data[index].fecha_solicitado = moment();

        list.push(this.$http.post('presupuestos_' + this.type + '/', data[index]));
      }
      Promise.all(list).then(results => {
        this.selected_entidades = [];
        this.loadPptos();
        this.selected_entidades = [];
        this.entidades = [];
        this.page = 1;
        this.showPptoForm = false;
      });
    },
    editAparato: function (item) {
      this.newVehiculo = item;
      this.showVForm = true;
    },
    deleteAparato: function (item) {
      this.$http.delete('aparatos_' + this.type + '/' + item.id + '/').then(result => {
        this.aparatos = this.aparatos.filter(e => e.id !== item.id);
      });
    },
    editCombustible: function (item) {
      this.newCombustible = item;
      this.showCForm = true;
    },
    deleteCombustible: function (item) {
      this.$http.delete('combustibles_' + this.type + '/' + item.id + '/').then(result => {
        this.combustibles = this.combustibles.filter(e => e.id !== item.id);
      });
    },
    addVehiculo: function () {
      this.newVehiculo = {
        id: null,
        potencia_or_consumo: null,
        tipo: 'APARATO',
        aparato_or_vehiculo: null,
        id_comercial: this.detalles.id,
        id_caldera: this.detalles.id
      };
      this.showVForm = true;
    },
    saveVForm: function () {
      this.$validator.validate().then(result => {
        if (!result) {
          alert('Tienes algún error en el formulario');
        } else {
          if (this.aparatos_string === 'Tipo y Nº de Vehículos') {
            this.newVehiculo.tipo = 'VEHICULO';
          }
          if (this.newVehiculo.id) {
            this.$http.put('aparatos_' + this.type + '/' + this.newVehiculo.id + '/', this.newVehiculo).then(result => {
              this.aparatos = this.aparatos.filter(e => e.id !== result.data.id);
              this.aparatos.push(result.data);
              this.newVehiculo = {
                id: null,
                potencia_or_consumo: null,
                tipo: 'APARATO',
                aparato_or_vehiculo: null,
                id_comercial: this.detalles.id,
                id_caldera: this.detalles.id
              };
              this.showVForm = false;
            });
          } else {
            this.$http.post('aparatos_' + this.type + '/', this.newVehiculo).then(result => {
              this.aparatos.push(result.data);
              this.newVehiculo = {
                id: null,
                potencia_or_consumo: null,
                tipo: 'APARATO',
                aparato_or_vehiculo: null,
                id_comercial: this.detalles.id
              };
              this.showVForm = false;
            });
          }
        }
      });
    },
    addCombustible: function () {
      this.newCombustible = {
        id: null,
        uso: null,
        combustible: null,
        consumo_anual: null,
        id_comercial: this.detalles.id,
        id_caldera: this.detalles.id
      };
      this.showCForm = true;
    },
    saveCForm: function () {
      this.$validator.validate().then(result => {
        if (!result) {
          alert('Tienes algún error en el formulario');
        } else {
          if (this.newCombustible.id) {
            this.$http.put('combustibles_' + this.type + '/' + this.newCombustible.id + '/', this.newCombustible).then(result => {
              this.combustibles = this.combustibles.filter(e => e.id !== result.data.id);
              this.combustibles.push(result.data);
              this.newCombustible = {
                id: null,
                uso: null,
                combustible: null,
                consumo_anual: null,
                id_comercial: this.detalles.id
              };
              this.showCForm = false;
            });
          } else {
            this.$http.post('combustibles_' + this.type + '/', this.newCombustible).then(result => {
              this.combustibles.push(result.data);
              this.newCombustible = {
                id: null,
                uso: null,
                combustible: null,
                consumo_anual: null,
                id_comercial: this.detalles.id
              };
              this.showCForm = false;
            });
          }
        }
      });
    },
    cancel: function () {
      if (this.newComercial) {
        this.$emit('close');
      } else {
        this.loading = 1;
        var id = this.feature.id.split('.')[1];
        if (this.type === 'caldera') {
          id = this.feature.properties.id;
        }
        this.$http.get(this.type + '/' + id + '/').then(result => {
          this.detalles = result.data;
          this.loading = 0;
        });
      }
    },
    saveNew: function () {
      this.loading = 1;
      if (this.detalles.fecha_presupuesto_entregado === '') {
        this.detalles.fecha_presupuesto_entregado = null;
      }
      if (this.detalles.fecha_cambio_status === '') {
        this.detalles.fecha_cambio_status = null;
      } else {
        this.detalles.fecha_cambio_status = this.detalles.fecha_cambio_status.split('T')[0];
      }
      return this.detalles;
    },
    save: function (event, triggeredExternally = false) {
      console.log('GESTION');
      if (this.newComercial) {
        this.$emit('save');
      } else {
        this.$validator.validate().then(result => {
          if (!result) {
            alert('Tienes algún error en el formulario');
          } else {
            this.loading = 1;
            if (this.detalles.fecha_presupuesto_entregado === '' || this.detalles.fecha_presupuesto_entregado === null) {
              this.detalles.fecha_presupuesto_entregado = null;
            } else {
              this.detalles.fecha_presupuesto_entregado = this.detalles.fecha_presupuesto_entregado.split('T')[0];
            }
            if (this.detalles.fecha_cambio_status === '' || this.detalles.fecha_cambio_status === null) {
              this.detalles.fecha_cambio_status = null;
            } else {
              this.detalles.fecha_cambio_status = this.detalles.fecha_cambio_status.split('T')[0];
            }

            let fieldsUsedInGestionTab = {
              id: this.detalles['id'],
              latitud_original: this.detalles['latitud_original'],
              longitud_original: this.detalles['longitud_original'],
              geom: this.detalles['geom'],
              ['id_clase_establecimiento_gn_' + this.type]: this.detalles['id_clase_establecimiento_gn_' + this.type],
              'id_gas_finca': this.detalles['id_gas_finca'],
              ['id_status_gestion_' + this.type]: this.detalles['id_status_gestion_' + this.type],
              fecha_cambio_status: this.detalles['fecha_cambio_status'],
              cliente: this.detalles['cliente'],
              motivo_no_potencial: this.detalles['motivo_no_potencial'],
              motivo_rechazo: this.detalles['motivo_rechazo'],

              nombre_propietario: this.detalles['nombre_propietario'],
              telefono_propietario: this.detalles['telefono_propietario'],
              email_propietario: this.detalles['email_propietario'],

              nombre_presidente: this.detalles['nombre_presidente'],
              telefono_presidente: this.detalles['telefono_presidente'],
              email_presidente: this.detalles['email_presidente'],

              nombre_administrador_finca: this.detalles['nombre_administrador_finca'],
              telefono_administrador_finca: this.detalles['telefono_administrador_finca'],
              email_administrador_finca: this.detalles['email_administrador_finca'],

              observaciones: this.detalles['observaciones'],
              datos_contacto: this.detalles['datos_contacto'],
              empresa_instaladora: this.detalles['empresa_instaladora']
            };

            console.log('GESTION SAVE...', fieldsUsedInGestionTab);
            this.$http.patch(this.type + '/' + this.feature.id.split('.')[1] + '/', fieldsUsedInGestionTab).then(result => {
              console.log('...GESTION SAVED');
              if (!triggeredExternally) { console.log('EMITTING GESTION'); this.$emit('triggerComercialSave', 'gestion'); }
              if (this.type === 'comercial') {
                this.$emit('comercialSaved');
              } else if (this.type === 'caldera') {
                this.$emit('calderaSaved');
              }
              this.detalles = result.data;
              if (this.sendingEmail) {
                this.$http.post('sendEmail/', {id: this.detalles.id, type: this.type}).then(result => {
                  this.sendingEmail = false;
                  // console.log(result)
                });
              }
              this.loading = 0;
            });
          }
        });
      }
    },
    BoolToEsp: function (b) {
      if (b) {
        return 'Si';
      } else {
        'required:true';
        return 'No';
      }
    },
    hasPermision: function (p) {
      var rol = '';
      if (this.type === 'caldera') {
        rol = 'CALDERA CENTRALIZADA';
      } else {
        rol = 'COMERCIAL';
      }
      return this.permisos[rol][p];
    },
    loadAparatos: function () {
      var url = 'tipo_aparato/';
      if (this.aparatos_string === 'Tipo y Nº de Vehículos') {
        url = 'tipo_vehiculo/';
      }
      this.$http.get(url, {params: {not_paginated: true}}).then(result => {
        this.aparatos_tipos_options = [''].concat(result.data.map(e => e.tipo));
      });
    },
    loadCombustibles: function () {
      Promise.all([
        this.$http.get('combustibles/', {params: {not_paginated: true}}),
        this.$http.get('tipo_usos/', {params: {not_paginated: true}})
      ]).then(results => {
        // this.combustibles_tipos_options = [{combustible: ''}].concat(results[0].data)
        this.combustibles_tipos_options = [''].concat(results[0].data.map(e => e.combustible));
        this.combustibles_usos_options = [''].concat(results[1].data.map(e => e.tipo_uso));
        // this.combustibles_usos_options = [{tipo_uso: ''}].concat(results[1].data)
      });
    },
    setFechaCambioStatus () {
      this.detalles.fecha_cambio_status = this.$moment().format('YYYY-MM-DD');
    },
    loadPptos: function () {
      this.$http.get('presupuestos_' + this.type + '/', {params: {['id_' + this.type]: this.detalles.id, not_paginated: true}}).then(result => {
        this.presupuestos = result.data;
      });
    },
    calcDireccion: function () {
      if (this.detalles.tipo_via && this.detalles.nombre_via && this.detalles.numero) {
        this.detalles.direccion_estructurada = this.detalles.tipo_via + ' ' + this.detalles.nombre_via + ', ' + this.detalles.numero;
        if (this.detalles.anexo) {
          this.detalles.direccion_estructurada = this.detalles.direccion_estructurada + ' ' + this.detalles.anexo;
        }
      }
    }
  },
  mounted: function () {
    this.loading = 1;
    var id = this.feature.id.split('.')[1];
    if (this.type === 'caldera') {
      id = this.feature.properties.id;
    }

    if (!this.newComercial) {
      this.$http.get(this.type + '/' + id + '/').then(result => {
        this.detalles = result.data;

        this.loadPptos();

        if (this.detalles['id_clase_establecimiento_gn_' + this.type].id === 5) {
          this.aparatos_string = 'Tipo y Nº de Vehículos';
        } else {
          this.aparatos_string = 'Aparatos y potencia';
        }

        this.newVehiculo.id_comercial = this.detalles.id;
        this.newCombustible.id_comercial = this.detalles.id;

        var params = {params: {not_paginated: true}};
        params.params['id_' + this.type] = this.detalles.id;

        Promise.all([
          this.$http.get('clase_establecimiento_comercial/', {params: {not_paginated: true}}),
          this.$http.get('gas_finca/', {params: {not_paginated: true}}),
          this.$http.get('status_gestion_' + this.type + '/', {params: {not_paginated: true}}),
          this.$http.get('motivo_no_potencial_comercial/', {params: {not_paginated: true}}),
          this.$http.get('motivo_rechazo_comercial/', {params: {not_paginated: true}}),
          this.$http.get('aparatos_' + this.type + '/', params),
          this.$http.get('combustibles_' + this.type + '/', params)
        ]).then(results => {
          this.clase_establecimiento_comercial_options = [{id: null, tipo: ''}].concat(results[0].data);
          this.gas_options = [{id: null, gas: ''}].concat(results[1].data);
          this.status_options = [{id: null, status: ''}].concat(results[2].data);
          this.motivo_no_potencial_options = [{id: null, motivo: ''}].concat(results[3].data);
          if (this.detalles.motivo_no_potencial && this.motivo_no_potencial_options.findIndex(e => e === this.detalles.motivo_no_potencial) < 0) {
            this.motivo_no_potencial_options = this.motivo_no_potencial_options.concat([{id: 999, motivo: this.detalles.motivo_no_potencial}]);
          }
          this.motivo_rechazo_options = [{id: null, motivo: ''}].concat(results[4].data);

          this.aparatos = results[5].data;
          this.combustibles = results[6].data;

          this.loading = 0;

          this.loadAparatos();
          this.loadCombustibles();
          // this.loadPoblacion(true)
        });
      });
    } else {
      this.detalles = this.feature.properties;
      Promise.all([
        this.$http.get('clase_establecimiento_comercial/', {params: {not_paginated: true}}),
        this.$http.get('gas_finca/', {params: {not_paginated: true}}),
        this.$http.get('status_gestion_' + this.type + '/', {params: {not_paginated: true}}),
        this.$http.get('motivo_no_potencial_comercial/', {params: {not_paginated: true}}),
        this.$http.get('motivo_rechazo_comercial/', {params: {not_paginated: true}})
      ]).then(results => {
        this.clase_establecimiento_comercial_options = [{id: null, tipo: ''}].concat(results[0].data);
        this.gas_options = [{id: null, gas: ''}].concat(results[1].data);
        this.status_options = [{id: null, status: ''}].concat(results[2].data);
        this.motivo_no_potencial_options = [{id: null, motivo: ''}].concat(results[3].data);
        this.motivo_rechazo_options = [{id: null, motivo: ''}].concat(results[4].data);

        this.aparatos = [];
        this.combustibles = [];

        this.loading = 0;

        this.loadAparatos();
        this.loadCombustibles();
      });
    }
  },
  computed: {
    isScroll: function () {
      if (this.loading < 1 && !this.showCForm && !this.showVForm) { // && (this.showPptoForm || this.showPptoTable || this.editPptoFlag) && !this.showCForm && !this.showVForm) {
        return 'scroll';
      } else {
        return '';
      }
    },
    noPotencialValidate: function () {
      if (this.detalles['id_status_gestion_' + this.type].id === 8) {
        return {required: true};
      } else {
        return {is: null};
      }
    },
    rechazadoValidate: function () {
      if (this.detalles['id_status_gestion_' + this.type].id === 5) {
        return {required: true};
      } else {
        return {is: null};
      }
    },
    isRequired: function () {
      if (this.detalles['id_status_gestion_' + this.type].id === 8 && this.detalles.motivo_no_potencial === 'Ya es cliente') {
        return 'required:true';
      } else {
        return 'required';
      }
    },
    isRequired2: function () {
      if (this.detalles['id_status_gestion_' + this.type].id === 8 && this.detalles.motivo_no_potencial === 'Ya es cliente') {
        return {'is': 1};
      } else if (this.detalles.cliente) {
        return {'is': 1};
      } else {
        return 'required';
      }
    }
  },
  watch: {
    detalles: function () {
      this.calcDireccion();
    },
    feature: function () {
      if (this.newComercial) {
        this.detalles = this.feature.properties;
      }
    },
    aparatos_string: function () {
      this.loadAparatos();
    },
    'detalles.id_clase_establecimiento_gn_comercial.id': function () {
      if (this.detalles['id_clase_establecimiento_gn_' + this.type].id === 5) {
        this.aparatos_string = 'Tipo y Nº de Vehículos';
      } else {
        this.aparatos_string = 'Aparatos y potencia';
      }
    },
    'feature.properties.id_clase_establecimiento_gn_comercial' () {
      this.detalles.id_clase_establecimiento_gn_comercial = this.feature.properties.id_clase_establecimiento_gn_comercial;
    },
    'feature.properties.id_clase_establecimiento_gn_caldera' () {
      this.detalles.id_clase_establecimiento_gn_caldera = this.feature.properties.id_clase_establecimiento_gn_caldera;
    },
    'feature.properties.id_status_gestion_comercial' () {
      this.detalles.id_status_gestion_comercial = this.feature.properties.id_status_gestion_comercial;
    },
    'feature.properties.id_status_gestion_caldera' () {
      this.detalles.id_status_gestion_caldera = this.feature.properties.id_status_gestion_caldera;
    },
    'feature.properties.cliente' () {
      this.detalles.cliente = this.feature.properties.cliente;
    },
    'feature.properties.id_gas_finca' () {
      if (this.type === 'comercial') {
        this.detalles.id_gas_finca = this.feature.properties.id_gas_finca;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Map/Details/comercial_gestion.vue